import { characters } from "../data/characters";
const queue = require("queue");
const q = queue({ results: [] });
q.concurrency = 3;

const loadImage = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onerror = reject;
    img.onload = () => {
      resolve(img);
    };
  });
};

Object.values(characters).forEach((c) => {
  q.push(() => loadImage(c.selected));
  q.push(() => loadImage(c.deselected));
  q.push(() => loadImage(c.icon));
});

// q.on("end", () => {
//   console.log(q.results);
// });
q.on("error", (err) => {
  console.error(`Queue error: ${err}`);
});

export const preloadQueue = q;
